import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { CONFIG } from 'src/app/_config/config';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PieTileWidgetsService {
 gateway = this.config.gateway;

  url = `${this.gateway.url}/funcion`;

  constructor(private http: HttpClient, private config: CONFIG
    ) {
  }
  getFunctionByName(name) {
    /// obtener datos desde servicio de consulta
    return new Subject();  // this.functionsService.getFunctionByName(name);
  }

  getData(dataArgs) {
    let args: any;
    args = dataArgs;
    return this.http.post(`${this.url}/resultQuery`, args);
  }

}
